<div class="weaveFormField"
  [ngClass]="{'error': name.invalid && (name.dirty || name.touched)}"
  >
  <div class="weaveSelect">
    <mat-form-field
      class="fullWidth"
      appearance="outline"
      [hideRequiredMarker]="hideRequiredMarker"
    >
      <mat-label>{{ label }}</mat-label>
      <mat-select
        panelClass="wrap-mat-select-options"
        [(ngModel)]="model"
        [id]="id"
        [disabled]="disabledFlag"
        (selectionChange)="onFocusOut()"
        [aria-label]="label"
        [required]="required"
        #name="ngModel"
        [multiple]="multiple"
        >
        <mat-option>
          <ngx-mat-select-search
            [(ngModel)]="searchCtrl"
            [placeholderLabel]="placeholder"
            [noEntriesFoundLabel]="'Not found'"
            name="search"
          ></ngx-mat-select-search>
        </mat-option>
        @if (minlength === 0 || searchCtrl.length >= minlength) {
          @for (item of options | programSearchFilter: searchCtrl; track item) {
            <mat-option class="weaveSelectOption" [value]="item.value">
              {{item.label}}
            </mat-option>
          }
        }
        @if (selectedOption && minlength && searchCtrl.length < minlength && selectedOption.value) {
          <mat-option class="weaveSelectOption" [value]="selectedOption.value">
            {{selectedOption.label}}
          </mat-option>
        }
      </mat-select>
      <mat-error *ngIf="name.invalid && (name.dirty || name.touched)">
        {{label}} is required
      </mat-error>
    </mat-form-field>
  </div>
</div>
